import { getProfileClient } from '@confluence/profile/entry-points/getProfileClient.ts';
import type { FeatureFlagsType } from '@confluence/session-data/entry-points/SessionDataTypes.ts';

import type { ProfileCardProvider, ProfileCardGetActions } from './types.ts';

export function getProfileCardProvider(
	cloudId: string,
	getActions: ProfileCardGetActions,
	/**
	 * @deprecated This is no longer used we should remove in a future version
	 */
	featureFlags: FeatureFlagsType,
): Promise<ProfileCardProvider> {
	return Promise.resolve({
		cloudId,
		resourceClient: getProfileClient(cloudId, featureFlags),
		getActions,
	});
}
